import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const localStorageLanguageKey = 'pg_language';
export type LanguagesType = 'it' | 'en';

const useCustomTranslations = () => {
  const { t, i18n } = useTranslation();
  const selectedLanguage = i18n.language as LanguagesType;

  const init = useCallback(() => {
    // Get current WPML language
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const currentLanguage = (window as any)['WPML_LANGUAGE'];

    i18n.changeLanguage(currentLanguage);

    // const qsLang = new URLSearchParams(window.location.search).get('lang');

    // if (qsLang !== null && (qsLang === 'it' || qsLang === 'en')) {
    //   if (qsLang !== selectedLanguage) {
    //     changeLanguage(qsLang as LanguagesType);
    //   }
    // } else if (localStorage.getItem(localStorageLanguageKey)) {
    //   const storedLang = localStorage.getItem(
    //     localStorageLanguageKey,
    //   ) as LanguagesType;
    //   changeLanguage(storedLang);
    // } else {
    //   changeLanguage('en');
    // }
  }, []);

  // const changeLanguage = useCallback((language: LanguagesType) => {
  //   i18n.changeLanguage(language, () => {
  //     localStorage.setItem(localStorageLanguageKey, language);
  //     const qs = new URLSearchParams(window.location.search);
  //     if (qs.get('lang') !== language) {
  //       qs.set('lang', language);
  //       const newUrl = `${window.location.pathname}?${qs.toString()}`;
  //       window.history.pushState({}, '', newUrl);
  //     }
  //   });
  // }, []);

  return { init, t, /*changeLanguage,*/ selectedLanguage };
};

export default useCustomTranslations;
